import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-question-row',
  templateUrl: './question-row.component.html',
  styleUrl: './question-row.component.css'
})
export class QuestionRowComponent {

  @Input() row: any;
  @Input() showChecked: boolean = true;

  @Output() visibilityChange = new EventEmitter<{row: any, checked: boolean}>();

  onCheckboxChange(event: any) {
    const newVisibility = this.row.visible === 1 ? 0 : 1;
    this.visibilityChange.emit({ row: this.row, checked: newVisibility === 1 });
  }

  truncateText(text: string, maxLength: number): string {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  }
}
